import emptyIconProfile from "../../images/emptyIconProfile.svg"
import phoneHeadset from "../../images/phoneHeadset.svg"
import envelope from "../../images/envelope.svg"
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Image, Row} from "antd";
import {useNavigate, useParams} from "react-router-dom";
import {DiplomaCard} from "../../Components/DiplomaCard";
import usePortalService from "../../services/PortalService";
import { Tooltip } from 'antd';
import star from '../../images/star.svg';
import { AdminNavbar } from "../../Components/Navbars";
import { Diploma } from "../../types";

const Styles = styled.div`
`

/* const Tag = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color : #29A340;
  background-color: #EFFBF1;
  border: 1px solid #DEF7E3;
  border-radius: 2em;
  height : 60%;
  padding: 0 0.65em 0.45em 0.65em;
  margin-bottom: 1em;
` */

const TextBlock = styled.p`
  line-height: 22px;
  white-space: pre-line;
  letter-spacing: 0em;
  font-size: 14px;
`

const HeaderText = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  text-align: left;
  color: #222222;
  margin-bottom: 8px;
`

let profileId: string;
export const StudentAccauntForAdmin = () => {
  const {profileAllInformationForAdmin, getAvatar} = usePortalService();

  const params = useParams();
  profileId = params.id as string;

  /* const navigate = useNavigate() */

  const [isBottom, setIsBottom] = useState<boolean | null>(null);
  /* const [modalOpen, setModalOpen] = useState(false); */

  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [status, setStatus] = useState('')
  const [rating, setRating] = useState(0)
  const [address, setAddress] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [educationLevel, setEducationLevel] = useState('')
  const [institution, setInstitution] = useState('')
  const [yearGraduation, setYearGraduation] = useState(0)
  const [specialtyName, setSpecialtyName] = useState('')
  const [isTargetEducation, setIsTagetEducation] = useState(false)
  const [targetCompany, setTargetCompany] = useState('')
  const [about, setAbout] = useState('')
  const [avatar, setAvatar] = useState('');
  const [isAvatarLoad, setIsAvatarLoad] = useState(false);

  const [position, setPosition] = useState('')

  const [diplomas, setDiplomas] = useState<Diploma[]>([])

  const handleScroll = () => {
    const element = document.getElementById("main");

    setIsBottom(element && element.getBoundingClientRect().bottom - window.innerHeight <= 10)
  }

  const detectPosition = (yearGraduation: number) => {
    if (yearGraduation == 0) {
      return;
    }
    const now = new Date();
    const currentYear = now.getFullYear();
    const academicYearIsOver = (now.getMonth() > 5)
    if (currentYear > yearGraduation) {
      setPosition("Выпускник "+yearGraduation+" года.")
    } else if (currentYear == yearGraduation) {
      if (academicYearIsOver) {
        setPosition("Выпускник этого года.")
      } else {
        setPosition("Студент, последний курс.")
      }
    } else {
      const course = 4 - (yearGraduation - currentYear) + (academicYearIsOver ? 1 : 0)
      setPosition("Студент, "+course+" курс.")
    }
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("resize", () => handleScroll());

    (
      async () => {
        profileAllInformationForAdmin(profileId).then(result => {
          if (result.success) {
            setLastName(result.profile.lastName)
            setFirstName(result.profile.firstName)
            setPatronymic(result.profile.patronymic)
            setStatus(result.profile.status)
            setRating(result.profile.rating)
            setAddress(result.profile.address)
            setPhone(result.profile.phoneNumber)
            setEmail(result.profile.email)
            setEducationLevel(result.profile.educationLevel)
            setInstitution(result.profile.educationalInstitution)
            setYearGraduation(result.profile.yearGraduation)
            setSpecialtyName(result.profile.specialtyName)
            setAbout(result.profile.aboutMe)
            setIsTagetEducation(result.profile.isTargetEducation)
            setTargetCompany(result.profile.targetCompany)
            if (result.profile.avatarId) {
              getAvatar(result.profile.avatarId)  
              .then(result => {
                  setAvatar(result)
                  setIsAvatarLoad(true)
              })
            } else {
                setAvatar(emptyIconProfile)
            }
            detectPosition(Number(result.profile.yearGraduation))
            setDiplomas(result.profile.certificates);
          }
        })
      }
    )()
  },[])

  return(
    <Styles id="main">
      <AdminNavbar />
      <div className="page700 d-flex flex-column gap-4">
        <div className='d-flex gap-3'>
          <Image src={avatar} preview={isAvatarLoad} style={{height : 112, objectFit : "cover", aspectRatio: "1/1", borderRadius : "0.5em"}}/>
          <div className="d-flex flex-column gap-1">
            <div className="header-card">
              <h1 style={{display:'inline-block', marginRight: '8px'}}>{lastName} {firstName} {patronymic}</h1>
              {(status) && <div className="find-candidate-card"> {status} </div>}
            </div>
            <div className="row-container">
                <img src={star} width="16px" style={{marginTop:'-5px'}}/>
                <p className="hours-number" style={{ marginBottom: '4px' }}>
                    {rating}
                </p>
                <Tooltip placement='bottom'
                title="Рейтинг РТСИМ - рейтинг, основанный на данных по использованию компьютерных тренажеров РТСИМ.Карьера.">
                    <h6 style={{ marginBottom: '4px' }}>
                        Рейтинг РТСИМ
                    </h6>
                </Tooltip>
            </div>
            {
              !(position && (isTargetEducation && targetCompany || !isTargetEducation))
                ? <TextBlock>Образование не заполнено</TextBlock>
                : <TextBlock> {position} {isTargetEducation ? `Целевой (${targetCompany})` : null}</TextBlock>
            }
            {
              !(address)
                ? <TextBlock>Адрес не заполнен</TextBlock>
                : <TextBlock> {address} </TextBlock>
            }
            <div className="d-flex gap-2">
              {(phone) && <>
              <div className="position-relative" style={{width : "16px"}}>
                <img height="16px" className="position-absolute" src={phoneHeadset} style={{bottom : "15%"}}/>
              </div>
              <TextBlock>{phone}</TextBlock>
              </>}
              &nbsp;
              {(email) && <>
              <div className="position-relative" style={{width : "14px"}}>
              <img height="14px" className="position-absolute" src={envelope} style={{bottom : "15%"}}/>
              </div>
              <TextBlock>{email}</TextBlock>
              </>}
            </div>

          </div>
        </div>
        <div>
          <HeaderText>{educationLevel}</HeaderText>
          <TextBlock>
            {`${yearGraduation ? `${yearGraduation} год окончания` : 'Год окончания : не заполнено'}
            ${institution ?? 'Образовательное учреждение : не заполнено'}
            ${specialtyName ?? 'Название специальности : не заполнено'}`}
          </TextBlock>
        </div>
        <div>
          <HeaderText>Обо мне</HeaderText>
          <TextBlock>
            {(about) ? about : "Не заполнено"}
          </TextBlock>
        </div>
        <div>
          <HeaderText>Дипломы и сертификаты</HeaderText>
          {
            diplomas.length === 0
              ? <TextBlock>Не загружено</TextBlock>
              :
              <Row>
                {diplomas.map(diploma =>
                  <DiplomaCard key={diploma.id} diploma={diploma} />
                )}
              </Row>
          }
        </div>
      </div>
    </Styles>
  )
}